import React from 'react';
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap";
import { useLocalStorage } from "./useLocalStorage";
import config from './config.json';

const Step33 = ({ nextStep, setStep, setStep13OptionLocal }) => {

  const currentStep = 33;
  const [dataLocal, setDataLocal] = useLocalStorage("household_people", 1);

  const handleChange = (e) => {
    setDataLocal(Number(e.target.value));
    };  

    const increment = () => {
      if (dataLocal < 25) {
        setDataLocal(dataLocal + 1);
      }
    };
  
    const decrement = () => {
      if (dataLocal > 1) {
        setDataLocal(dataLocal - 1);
      }
    };

    const prevSteps = () => {
      setStep(31);
    }

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if(dataLocal === 1) {
      setStep13OptionLocal({
        personne1: dataLocal === 1,
      });
    }

    else if(dataLocal === 2) {
      setStep13OptionLocal({
        personne2: dataLocal === 2,
      });
    }

    else if(dataLocal === 3) {
      setStep13OptionLocal({
        personne3: dataLocal === 3,
      });
    }

    else if(dataLocal === 4) {
      setStep13OptionLocal({
        personne4: dataLocal === 4,
      });
    }

    else if(dataLocal === 5) {
      setStep13OptionLocal({
        personne5: dataLocal === 5,
      });
    }

    else if(dataLocal === 6) {
      setStep13OptionLocal({
        personne6: dataLocal === 6,
      });
    }

    else if(dataLocal === 7) {
      setStep13OptionLocal({
        personne7: dataLocal === 7,
      });
    }

    else if(dataLocal === 8) {
      setStep13OptionLocal({
        personne8: dataLocal === 8,
      });
    }

    else if(dataLocal === 9) {
      setStep13OptionLocal({
        personne9: dataLocal === 9,
      });
    }

    else if(dataLocal === 10) {
      setStep13OptionLocal({
        personne10: dataLocal === 10,
      });
    }

    else if(dataLocal === 11) {
      setStep13OptionLocal({
        personne11: dataLocal === 11,
      });
    }

    else if(dataLocal === 12) {
      setStep13OptionLocal({
        personne12: dataLocal === 12,
      });
    }

    else if(dataLocal === 13) {
      setStep13OptionLocal({
        personne13: dataLocal === 13,
      });
    }

    else if(dataLocal === 14) {
      setStep13OptionLocal({
        personne14: dataLocal === 14,
      });
    }

    else if(dataLocal === 15) {
      setStep13OptionLocal({
        personne15: dataLocal === 15,
      });
    }

    else if(dataLocal === 16) {
      setStep13OptionLocal({
        personne16: dataLocal === 16,
      });
    }

    else if(dataLocal === 17) {
      setStep13OptionLocal({
        personne17: dataLocal === 17,
      });
    }

    else if(dataLocal === 18) {
      setStep13OptionLocal({
        personne18: dataLocal === 18,
      });
    }

    else if(dataLocal === 19) {
      setStep13OptionLocal({
        personne19: dataLocal === 19,
      });
    }

    else if(dataLocal === 20) {
      setStep13OptionLocal({
        personne20: dataLocal === 20,
      });
    }

    else if(dataLocal === 21) {
      setStep13OptionLocal({
        personne21: dataLocal === 21,
      });
    }

    else if(dataLocal === 22) {
      setStep13OptionLocal({
        personne22: dataLocal === 22,
      });
    }

    else if(dataLocal === 23) {
      setStep13OptionLocal({
        personne23: dataLocal === 23,
      });
    }

    else if(dataLocal === 24) {
      setStep13OptionLocal({
        personne24: dataLocal === 24,
      });
    }

    else if(dataLocal === 25) {
      setStep13OptionLocal({
        personne25: dataLocal === 25,
      });
    }

    nextStep();
  };

    return (
        <Container>
          <ProgressBar
            now={(currentStep / 36) * 100}
            style={{ backgroundColor: "#bad7f1" }}
          >
          <ProgressBar
            now={(currentStep / 36) * 100}
            style={{ backgroundColor: "#0be288" }}
          />
          </ProgressBar>
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Col>
                  <h2>{config.step33.step}</h2>
                  <h3>{config.step33.title}</h3>
              </Col>
            </Row>
            <Row className="mb-3 justify-content-center">
              <Col lg="6" offset-lg="3">
                <Form.Label>{config.step33.label}</Form.Label>
                  <div className="input-group">
                    <button type="button" className='btn btn-primary' onClick={decrement}>-</button>
                    <Form.Control
                      type="number"
                      value={dataLocal}
                      onChange={handleChange}
                      className='form-control'
                      readOnly
                      required
                    />
                    <button type="button" className='btn btn-primary' onClick={increment} disabled={dataLocal === 25}>+</button>
                  </div>
              </Col>
            </Row>
          <Row className="mt-3">
            <Col className="d-flex justify-content-between">
              <Button type="button" variant="secondary" onClick={prevSteps}>
                Précédent
              </Button>
              <Button type="submit" variant="primary" className="ms-3">
                Suivant
              </Button>
              </Col>
            </Row>
          </Form>
        </Container>

    );

}

export default Step33;